// src/components/ui/estadoPedido.js
// FUENTE ÚNICA del Sistema de Estados de pedidos (color + ícono).
// "Cambiar uno = cambiar todos; agregar uno = se agregan todos."
//
// Cualquier indicador de estado de pedido (badge de tabla/card, bullet de
// desglose, barra de gráfico, leyenda, KPI por estado) debe salir de acá,
// NUNCA inventar colores/iconos por archivo. Referencia: ESTETICA_GUIA.md §0.4
// y el faro src/components/pedidos/components/TablaPedidos.js.
//
// Para agregar un estado nuevo: una sola entrada en ESTADOS_PEDIDO y queda
// disponible en TODOS los consumidores.
import React from 'react';
import {
  SnowflakeIcon, PackageIcon, TruckIcon, CheckCircleIcon,
  ArrowUturnLeftIcon, XCircleIcon, FactCheckIcon, SparklesIcon
} from './Icons';

// Mapa canónico. `fondo`/`texto`/`color` son tokens (claro+oscuro).
export const ESTADOS_PEDIDO = {
  'CONGELADO':      { fondo: 'var(--color-info-fondo)',        texto: 'var(--color-info-texto)',        color: 'var(--color-info)',        Icon: SnowflakeIcon,      label: 'CONGELADO' },
  'POR ENVIAR':     { fondo: 'var(--color-naranja-fondo)',     texto: 'var(--color-naranja-texto)',     color: 'var(--color-naranja)',     Icon: PackageIcon,        label: 'POR ENVIAR' },
  'ENVIADO':        { fondo: 'var(--color-primario-suave)',    texto: 'var(--color-primario-texto)',    color: 'var(--color-primario)',    Icon: TruckIcon,          label: 'ENVIADO' },
  'ENTREGADO':      { fondo: 'var(--color-exito-fondo)',       texto: 'var(--color-exito-texto)',       color: 'var(--color-exito)',       Icon: CheckCircleIcon,    label: 'ENTREGADO' },
  'DEVOLUCIÓN':     { fondo: 'var(--color-advertencia-fondo)', texto: 'var(--color-advertencia-texto)', color: 'var(--color-advertencia)', Icon: ArrowUturnLeftIcon, label: 'DEVOLUCIÓN' },
  'ANULADO':        { fondo: 'var(--color-peligro-fondo)',     texto: 'var(--color-peligro-texto)',     color: 'var(--color-peligro)',     Icon: XCircleIcon,        label: 'ANULADO' },
  'POR VERIFICAR':  { fondo: 'var(--color-gris-fondo)',        texto: 'var(--color-gris-texto)',        color: 'var(--color-gris-texto)',  Icon: FactCheckIcon,      label: 'POR VERIFICAR' },
  'POR REVISAR IA': { fondo: 'var(--color-teal-fondo)',        texto: 'var(--color-teal-texto)',        color: 'var(--color-teal)',        Icon: SparklesIcon,       label: 'POR REVISAR IA' }
};

const FALLBACK = {
  fondo: 'var(--color-gris-fondo)', texto: 'var(--color-gris-texto)',
  color: 'var(--color-gris-texto)', Icon: null
};

// Devuelve la config de un estado. Normaliza: mayúsculas + DEVOLUCION (sin
// tilde, histórico) → DEVOLUCIÓN. Si no existe, fallback gris con el texto crudo.
export function estadoConfig(estado) {
  const crudo = estado == null ? '' : String(estado);
  const k = crudo.toUpperCase();
  const key = k === 'DEVOLUCION' ? 'DEVOLUCIÓN' : k;
  const cfg = ESTADOS_PEDIDO[key];
  if (cfg) return cfg;
  return { ...FALLBACK, label: crudo };
}

// Badge "pill" estándar para tablas y cards (mismo molde que TablaPedidos).
// La FORMA (radio, padding, ancho mínimo uniforme, etc.) vive en la clase global
// `.badge-estado` de globals.css → un solo lugar para TODO el sistema. Acá solo
// se pasan los colores del estado (que sí varían). `style` permite overrides
// puntuales (ej. otro minWidth) sin romper el estándar.
export function EstadoBadge({ estado, style }) {
  const cfg = estadoConfig(estado);
  const Icon = cfg.Icon;
  return (
    <span className="badge-estado" style={{
      background: cfg.fondo,
      color: cfg.texto,
      borderColor: cfg.color,
      ...style
    }}>
      {Icon && <Icon className="w-3 h-3" />} {cfg.label || estado}
    </span>
  );
}

// Ícono suelto en el color del estado, para desgloses/listas inline (ej. el
// "Desglose por estado" de los widgets). Reemplaza el viejo bullet `●`.
export function EstadoIcon({ estado, className = 'w-4 h-4' }) {
  const cfg = estadoConfig(estado);
  const Icon = cfg.Icon;
  if (!Icon) return null;
  return (
    <span style={{ color: cfg.color, display: 'inline-flex' }}>
      <Icon className={className} />
    </span>
  );
}
